<template>
  <div class="slider">
    <div class="watermark">
      Created with Powerslide.app
    </div>
    <vueper-slides
      :arrows="false"
      :autoplay="true"
      :bullets="false"
      fixedHeight="100vh"
      :pause-on-hover="false"
      ref="VueperSlides"
    >
      <vueper-slide v-for="(slide, i) in slides"
        :content="slide.content"
        :image="slide.image"
        :key="i"
        :style="'background-color: ' + slide.background"
        :title="slide.title"
        :video="slide.video"
      />
    </vueper-slides>
  </div>
</template>

<script>
import Helpers from '../mixins/helpers.js'
import { VueperSlide, VueperSlides } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  name: 'Slider2',
  components: {
    VueperSlide,
    VueperSlides
  },

  data () {
    return {
      currentSlide: 0,
      format: 'hh:mm',
      slides: []
    }
  },

  methods: {
    getScheduledSlides: function () {
      this.slides = []
      let currentTime = this.$moment()
      let currentDay = currentTime.day()

      this.slideshow.slides.forEach(slide => {
        if (slide.schedule === undefined || !slide.schedule.length) {
          this.slides.push(slide)
        } else if (slide.schedule.length > 0) {
          if (slide.schedule[currentDay].start_time === '' && slide.schedule[currentDay].end_time === '') {
            this.slides.push(slide)
          } else {
            let start = this.$moment(slide.schedule[currentDay].start_time, this.format)
            let end = this.$moment(slide.schedule[currentDay].end_time, this.format)

            if (currentTime.isBetween(start, end)) {
              this.slides.push(slide)
            }
          }
        }
      })

      if (this.slides.length === 1) {
        if (this.slides[this.currentSlide].type === 'video') {
          this.slides.length === 1 ? this.slides[this.currentSlide].video.props.loop = true : this.slides[this.currentSlide].video.props.loop = false
        }

        this.startScheduleCounter()
      }
    },

    nextSlide: function () {
      if (this.$refs.VueperSlides !== undefined) {
        this.$refs.VueperSlides.next()

        if (this.currentSlide < (this.slides.length - 1)) {
          this.currentSlide++
        } else {
          this.getScheduledSlides()
          this.currentSlide = 0
        }
        this.startSlideCounter()
      }
    },

    startScheduleCounter: function () {
      setTimeout(() => {
        this.startSlideCounter()
      }, this.slides[0].duration * 1000)
    },

    startSlideCounter: function () {
      setTimeout(() => {
        if (this.slides.length > 1) {
          this.nextSlide()
        } else {
          this.getScheduledSlides()
        }
      }, this.slides[this.currentSlide].duration * 1000)
    }
  },

  mixins: [Helpers],

  mounted: function () {
    if (this.slideshow) {
      this.getScheduledSlides()
      this.startSlideCounter()
    } else {
      this.$router.go(-1)
    }
  },

  props: ['slideshow']
}
</script>

<style scoped>
  .slider {
    width: 100vw;
  }

  .watermark {
    bottom: 0;
    color: var(--secondary);
    font-size: 1.25em;
    font-weight: 900;
    padding: .5em;
    position: fixed;
    right: 0;
    text-align: center;
    width: 300px;
    z-index: 999;
  }
</style>
